module.exports = __webpack_public_path__ + "static/media/AdobeCC_Step0_Titlecard.b306353b.jpg";